"use strict";
exports.__esModule = true;
exports.toEventItem = void 0;
var utils_1 = require("@lglp/utils");
var fields_1 = require("../fields");
var toEventItem = function (data, logger) {
    var prismicEvent = utils_1.unprefix('event', data);
    if (prismicEvent) {
        var date = logger.required(fields_1.toText(prismicEvent.date));
        var description = logger.required(fields_1.toText(prismicEvent.description));
        if (!date || !description) {
            return undefined;
        }
        return utils_1.compact({
            date: date,
            description: description
        });
    }
    return undefined;
};
exports.toEventItem = toEventItem;
//# sourceMappingURL=event.js.map